// FET-2766: PayPal availability is page-option driven.
//
// Whether PayPal is offered as a checkout payment method is controlled by the
// `data-paypal-enabled` attribute on #checkout-app-new, surfaced from a CMS page
// option (the same mechanism as `data-enable-address-autofill` and
// `data-checkout-skin`). This lets an environment where the BET-1274 backend fix
// (adyen-paypal-order-breakdown, PR #3371) is not yet deployed opt a page out of
// PayPal without a code change / redeploy.
//
// Default: ENABLED. When the attribute is absent or blank, PayPal is shown.
// PayPal is only hidden when the option is explicitly falsey.

const FALSEY = ['false', '0', 'no', 'off'];

/**
 * Resolve whether PayPal should be available, from a raw page-option value.
 *
 * @param {string|null|undefined} raw The `data-paypal-enabled` attribute value.
 * @returns {boolean} true (default) unless the value is an explicit falsey token.
 */
// eslint-disable-next-line import/prefer-default-export -- named export matches the other lib/* helpers
export const resolvePaypalEnabled = (raw) => {
	if (raw === null || raw === undefined || raw === '') {
		return true;
	}

	return !FALSEY.includes(String(raw).trim().toLowerCase());
};
